import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/advertiser/_layout")({
    component: AdvertiserLayout,
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.advertiser.title"),
        };
    },
});

function AdvertiserLayout() {
    return <Outlet />;
}
